import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Info from '@/components/info'
import User from '@/components/user'
import NotFound from '@/components/404'
import Login from '@/components/login'
import ChangePass from '@/components/changePass'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      alias: '/index',
      redirect:'/info',
      component: Index,
      meta: {auth: true},
      children:[{
		      path: 'info',
		      name: 'info',
		      component: Info,
		    },{
		      path: 'user',
		      name: 'user',
		      component: User,
      }]
    },{
	   	path:'*',
	    component: NotFound
	  },{
	   	path:'/login',
	    component: Login,
	  },{
	   	path:'/changePass',
	    component: ChangePass,
	  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js